const MovieAndSeriesCardSkeleton = () => {
  return (
    <div>
      <div className="lg:w-[250px] w-[130px] h-[400px] bg-[#1a1919] animate-pulse mt-2"></div>
    </div>
  );
};

export default MovieAndSeriesCardSkeleton;
